import { render } from "./CoursesListPage.vue?vue&type=template&id=75cc5749&ts=true"
import script from "./CoursesListPage.vue?vue&type=script&lang=ts"
export * from "./CoursesListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__